<template>
  <div :class="classes" :style="{'flex-direction':direction}">
    <slot></slot>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = 'wt-box'

export default {
  name: 'wt-box',
  props: {
    direction: {
      type: String,
      default: 'column'
    }
  },
  computed: {
    classes () {
      return `${prefixCls}`
    }
  }
}
</script>

<style lang="less">
.wt-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
